import {
  createAction,
  handleAggregatorResponse,
} from '@wix/communities-blog-client-common';
import { getQueryLocale } from '../../selectors/locale-selectors';

export const FETCH_CATEGORIES_SUCCESS = 'categories/FETCH_SUCCESS';

const fetchCategoriesRequest = createAction('categories/FETCH_REQUEST');
export const fetchCategoriesSuccess = createAction(FETCH_CATEGORIES_SUCCESS);
const fetchCategoriesFailure = createAction('categories/FETCH_FAILURE');

const fetchCategoriesAction =
  () =>
  (_dispatch, getState, { request }) => {
    const state = getState();
    const lang = getQueryLocale(state);
    const langQuery = lang ? `&lang=${lang}` : '';

    return request(
      `/_api/categories?offset=0&size=500&includeTranslations=true&includeSeo=true${langQuery}`,
    );
  };

const createFetchCategories =
  (action) =>
  (...args) =>
  (dispatch) => {
    dispatch(fetchCategoriesRequest());

    return dispatch(action(...args))
      .then((categories) => dispatch(fetchCategoriesSuccess(categories)))
      .catch(() => dispatch(fetchCategoriesFailure()));
  };

const fetchCategories = createFetchCategories(fetchCategoriesAction);
export const handleCategoriesResponse = createFetchCategories(
  handleAggregatorResponse,
);

export default fetchCategories;
